import React, { createContext, MutableRefObject, ReactNode, useContext, useEffect, useImperativeHandle, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useShortcut } from '../utils/utils';

const bootstrap = (window as any).bootstrap;

interface ModalContextType{
    hide?():Promise<void>;
}

export type ModalRef = {hide():Promise<void>}

export const ModalContext = createContext<ModalContextType>({})

export function Modal({modalRef, children, title, onHide, className = ''}:{modalRef?:MutableRefObject<ModalRef>, children:ReactNode, title?: ReactNode, className?:string, onHide:()=>void}){
    const ref = useRef<HTMLDivElement>(null);
    const bsModal = useRef(null);
    const callback = useRef(null);

    function localOnHide(){
        onHide();
        if(callback.current) 
            callback.current();
    }

    // this function allow modal over modal
    function fixBackdrop(){
        var a = ref.current.nextElementSibling;
        if(a && a.classList.contains("modal-backdrop")){
            a.classList.toggle("show")
            a.parentNode.insertBefore(a, ref.current);
            (a as HTMLDivElement).style.zIndex = "1055";
            setTimeout(() => a.classList.toggle("show"), 1)
        }
    }
        
    useEffect(function(){
        bsModal.current = new bootstrap.Modal(ref.current, {keyboard: false});
        ref.current.addEventListener('hidden.bs.modal', localOnHide);
        bsModal.current.show();
        fixBackdrop()
        return () => {bsModal.current.dispose()}
    }, []);

    useShortcut('Escape', hide)

    function hide(){
        return new Promise<void>(function(ok){
            callback.current = ok;
            bsModal.current.hide();
        })
        
    }

    useImperativeHandle(modalRef, () => ({
        hide
    }), [modalRef])

    return  createPortal(
        <ModalContext.Provider value={{hide}}>
            <div className={`modal fade ${className}`} ref={ref}>
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content shadow">
                        {title && <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button type="button" onClick={hide} className="btn-close"></button>
                        </div>}
                        <div className="modal-body">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </ModalContext.Provider>, document.body);
}

export function useModalHide():()=>Promise<void> {
    return useContext(ModalContext).hide
}